import { useCriteoBanner } from "../context/criteoBanner/CriteoBannerContext";

const useCriteoSpotLight = () => {
  const { bannerData } = useCriteoBanner();

  return bannerData;
};

export default useCriteoSpotLight;
